import {
    CadNextAdditionalInfoView,
    ApiCadAdditionalInfoDeletionResponse,
    ApiResultAdditionalInfoCreationResponse,
    ApiResultAdditionalInfosWithLinkedEventMap,
    ApiResultNarrativeCreationResponse,
    ApiResultNarrativeDeleteResponse,
    ApiResultNarrativeListResponse,
    ApiResultNarrativeEditResponse,
    ApiResultPinnedNarrativeListResponse,
    ApiResultNarrativePinResponse,
    NarrativeResource,
    V2Resource,
    NudgeObjectDto,
    BoloAdditionalInfo,
} from '@mark43/cad-api';

export type {
    AdditionalInfoNotificationManager,
    UnreadInfo,
} from './hooks/use-additional-infos/types';

export type AdditionalInfoView = CadNextAdditionalInfoView;

export type CreateNarrative = NarrativeResource.CreateNarrative;
export type CreateNarrativeResponse = ApiResultNarrativeCreationResponse;
export type DeleteNarrative = NarrativeResource.DeleteNarrative;
export type ListNarratives = NarrativeResource.ListNarratives;
export type ListNarrativesByIds = NarrativeResource.ListNarrativesByIds;
export type ListScheduledEventNarratives = NarrativeResource.ListScheduledEventNarratives;
export type ListNarrativesResponse = ApiResultNarrativeListResponse;
export type DeleteNarrativeResponse = ApiResultNarrativeDeleteResponse;

export type ListPinnedNarratives = NarrativeResource.ListPinnedNarratives;
export type PinNarrative = NarrativeResource.PinNarrative;
export type ListPinnedNarrativesResponse = ApiResultPinnedNarrativeListResponse;
export type PinNarrativeResponse = ApiResultNarrativePinResponse;

// TODO: RND-61328 remove when rollOutCadNarrativeFilteringAndFocusImprovementsEnabled is enabled globally
export type CreateAdditionalInfoNext = V2Resource.CreateAdditionalInfoV21;
export type CreateAdditionalInfoNextResponse = ApiResultAdditionalInfoCreationResponse;
export type DeleteAdditionalInfoLegacy = V2Resource.DeleteAdditionalInfo1;
export type DeleteAdditionalInfoLegacyResponse = ApiCadAdditionalInfoDeletionResponse;
export type GetAdditionalInfosByCursor = V2Resource.GetAdditionalInfosWithLinkedEventMap;
export type GetAdditionalInfosByCursorResponse = ApiResultAdditionalInfosWithLinkedEventMap;
export type GetAdditionalInfosByIds = V2Resource.GetAdditionalInfosByIdsWithLinkedEventMap;
export type GetScheduledEventsAdditionalInfos = V2Resource.GetScheduledEventsAdditionalInfosWithLinkedEventMap;

export interface AdditionalInfoFormViewNext {
    agencyEventId: number;
    text: string;
    isHighPriority: boolean;
    crossClassOptions: number[];
    toExternalCadIntegrations: number[];
}

export enum AdditionalInfoType {
    USER = 'USER',
    SYSTEM = 'SYSTEM',
    PROQA = 'PRO_QA',
    PRO_QA_DESC_INFO = 'PRO_QA_DESC_INFO',
    PRO_QA_KEY_QUESTION = 'PRO_QA_KEY_QUESTION',
    PRO_QA_COMMENT = 'PRO_QA_COMMENT',
    PRO_QA_CRITICAL = 'PRO_QA_CRITICAL',
    PRO_QA_SCRIPT = 'PRO_QA_SCRIPT',
    PRO_QA_UPDATE = 'PRO_QA_UPDATE',
    PRO_QA_URGENT = 'PRO_QA_URGENT',
}

export const PRO_QA_TYPES = [
    AdditionalInfoType.PROQA,
    AdditionalInfoType.PRO_QA_DESC_INFO,
    AdditionalInfoType.PRO_QA_KEY_QUESTION,
    AdditionalInfoType.PRO_QA_COMMENT,
    AdditionalInfoType.PRO_QA_CRITICAL,
    AdditionalInfoType.PRO_QA_SCRIPT,
    AdditionalInfoType.PRO_QA_UPDATE,
    AdditionalInfoType.PRO_QA_URGENT,
];

export enum Priority {
    STANDARD = 'STANDARD_UPDATE',
    HIGH = 'HIGH_PRIORITY_UPDATE',
}

export type StreamMap = {
    nudge: NudgeObjectDto;
    infos: {
        reset?: number[];
        create?: (AdditionalInfoView & { text?: string })[];
        delete?: { agencyEventId: number; id: number }[];
        update?: (AdditionalInfoView & { text?: string })[];
    };

    boloAdditionalInfo: {
        boloId: number;
        boloLinkId: number;
        boloAdditionalInfo: BoloAdditionalInfo;
    };
};

// EditNarrative is generated from BE PR #5609 (merged)
export type EditNarrative = NarrativeResource.EditNarrative;
export type { ApiResultNarrativeEditResponse };

export type EditScheduledEventNarrative = NarrativeResource.EditScheduledEventNarrative;
export type SetNarrativePriority = NarrativeResource.SetNarrativePriority;
export type SetScheduledEventNarrativePriority = NarrativeResource.SetScheduledEventNarrativePriority;
